import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Route, Clock, MapPin } from "lucide-react";
import api from "@/lib/api";

export default function SharedItinerary() {
  const { shareId } = useParams();
  const [itin, setItin] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/itineraries/share/${shareId}`).then((r) => setItin(r.data)).catch(() => setNotFound(true));
  }, [shareId]);

  if (notFound) return <div className="p-16 text-center text-muted-foreground">This itinerary link is no longer available.</div>;
  if (!itin) return <div className="p-10 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="mx-auto max-w-2xl px-4 py-8 md:px-8">
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Shared plan</span>
      <h1 className="flex items-center gap-2 font-serif text-3xl font-bold md:text-4xl"><Route className="text-primary" /> {itin.title}</h1>
      <p className="mb-6 mt-1 text-muted-foreground">A day around the CSRA, built with CSRAGo.</p>
      <ol className="relative space-y-4 border-l-2 border-dashed border-border pl-6">
        {itin.items.map((it, i) => (
          <li key={i} className="relative">
            <span className="absolute -left-[31px] flex h-6 w-6 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">{i + 1}</span>
            <Link to={it.slug ? `/place/${it.slug}` : it.place_id ? `/place/${it.place_id}` : "#"} className="card-hover flex gap-4 rounded-2xl border border-border bg-card p-3">
              {it.cover_image && <img src={it.cover_image} alt="" className="h-20 w-20 flex-shrink-0 rounded-xl object-cover" />}
              <div>
                <span className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-primary"><Clock size={12} /> {it.time_slot}</span>
                <h3 className="font-serif text-lg font-bold">{it.name}</h3>
                <p className="text-sm text-muted-foreground">{it.note}</p>
                {it.address && <p className="mt-0.5 flex items-center gap-1 text-xs text-muted-foreground"><MapPin size={11} /> {it.address}</p>}
              </div>
            </Link>
          </li>
        ))}
      </ol>
      <Link to="/itinerary" className="mt-8 inline-block rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground">Build your own</Link>
    </div>
  );
}
